import axios from "axios";
import SummaryAPI, { baseURL } from "../Commson/summaryApi";

const Axios = axios.create({
  baseURL: baseURL,
  withCredentials: true,
});

// ✅ Attach access token in request header
Axios.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem("accesstoken");

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Handle expired tokens in response interceptor
Axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem("refreshtoken");
      if (refreshToken) {
        const newAccessToken = await refreshacesstoken(refreshToken);

        if (newAccessToken) {
          localStorage.setItem("accesstoken", newAccessToken);
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return Axios(originalRequest);
        }
      }
    }

    return Promise.reject(error);
  }
);

// ✅ Refresh token function
const refreshacesstoken = async (refreshToken) => {
  try {
    const response = await axios({
      ...SummaryAPI.refreshtoken,
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
    });

    const accessToken = response.data?.data?.accessToken;
    if (accessToken) {
      localStorage.setItem("accesstoken", accessToken);
    }
    return accessToken;
  } catch (error) {
    console.error("Refresh token failed:", error);
    return null;
  }
};

export default Axios;
